module.exports = __webpack_public_path__ + "media/images/bottle-841ce0864dba8be0c44122615318b2f6.svg";